import React from "react";
import { Box, Button, Paper, TextField, Typography, } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { ButtonLoader } from "frontend/src/ui/button-loader";
import { TrackEntry } from "./track-entry";
import { PlaylistEntry } from "./playlist-entry";
var useStyles = makeStyles(function (theme) {
    var _a;
    return ({
        buttonsWrapper: (_a = {
                display: "flex",
                flexDirection: "column",
                "& .MuiButtonBase-root": {
                    marginTop: theme.spacing(1),
                }
            },
            _a[theme.breakpoints.up("sm")] = {
                flexDirection: "row",
                "& .MuiButtonBase-root": {
                    marginTop: theme.spacing(0),
                    marginRight: theme.spacing(1),
                },
            },
            _a),
    });
});
export var TimetableRulesetEdit = function (_a) {
    var title = _a.title, entries = _a.entries, isUpdating = _a.isUpdating, onPlaylistAdd = _a.onPlaylistAdd, onSubmit = _a.onSubmit, onEntryRemove = _a.onEntryRemove, onEntryTrackCountChange = _a.onEntryTrackCountChange, onEntryPlaylistChange = _a.onEntryPlaylistChange, onEntryPlaylistDurationChange = _a.onEntryPlaylistDurationChange, onEntryPlaylistPlayOrderChange = _a.onEntryPlaylistPlayOrderChange;
    var classes = useStyles();
    var changeTitle = function (evt) {
        return title.onChange(evt.target.value);
    };
    return (React.createElement(Box, { component: "form", onSubmit: onSubmit },
        React.createElement(Box, { component: Paper, p: 2 },
            React.createElement(Box, { display: "flex", alignItems: "flex-end" },
                React.createElement(TextField, { value: title.value, onChange: changeTitle, fullWidth: true, label: "Название программы", error: !!title.error, helperText: title.error })),
            React.createElement(Box, { mt: 1 },
                React.createElement(Box, { className: classes.buttonsWrapper },
                    React.createElement(ButtonLoader, { color: "primary", variant: "contained", isLoading: isUpdating, type: "submit" }, "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C"),
                    React.createElement(Button, { color: "primary", variant: "outlined", onClick: onPlaylistAdd, disabled: isUpdating }, "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u043F\u043B\u0435\u0439\u043B\u0438\u0441\u0442")))),
        React.createElement(Box, { mt: 2 }, entries.length === 0 ? (React.createElement(Box, { component: Paper, p: 2 },
            React.createElement(Typography, null, "\u0421\u0435\u0439\u0447\u0430\u0441 \u0432 \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u0435 \u043D\u0435\u0442 \u043D\u0438 \u043E\u0434\u043D\u043E\u0433\u043E \u043F\u043B\u0435\u0439\u043B\u0438\u0441\u0442\u0430 \u0438\u043B\u0438 \u0442\u0440\u0435\u043A\u0430."))) : (entries.map(function (entry, index) {
            return entry.data.type === "track" ? (React.createElement(Box, { mb: 2, key: entry.id },
                React.createElement(TrackEntry, { index: index, track: entry.data.track, onRemove: onEntryRemove }))) : (React.createElement(Box, { mb: 2, key: entry.id },
                React.createElement(PlaylistEntry, { index: index, trackCount: entry.data.trackCount, playlistId: entry.data.playlistId, duration: entry.data.duration, playlistPlayOrder: entry.data.playOrder, onPlaylistPlayOrderChange: onEntryPlaylistPlayOrderChange, onPlaylistDurationChange: onEntryPlaylistDurationChange, onPlaylistChange: onEntryPlaylistChange, onTrackCountChange: onEntryTrackCountChange, onRemove: onEntryRemove, durationOrTrackCountNotSelectedError: entry.errors.durationOrTrackCountNotSelected, playlistNotSelectedError: entry.errors.playlistNotSelected })));
        })))));
};
